import ContentTypes from "../../../../../lib/html5-software-library/src/ranj/eng/content/ContentTypes";
import DecisionContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/DecisionContent";
import DialogContentComponent from "../../../../../lib/html5-software-library/src/ranj/eng/content/DialogContentComponent";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import FadeToColorOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/transition-animations/FadeToColorOptions";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinFactory from "../../../core/ui/SkinFactory";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import NGTDialogPlayer from "../../../ngt/dialog/NGTDialogPlayer";
import EmailInteractionEvent from "../../../ngt/email/controller/EmailInteractionEvent";
import EmailBoxType from "../../../ngt/email/model/EmailBoxType";
import EmailConversation from "../../../ngt/email/model/EmailConversation";
import EmailDraftItem from "../../../ngt/email/model/EmailDraftItem";
import EmailInterfaceEvent from "../../../ngt/email/model/EmailInterfaceEvent";
import LaptopNavigateEvent from "../../../ngt/laptop/model/LaptopNavigateEvent";
import LaptopSkinKeyRegistry from "../../../ngt/laptop/model/LaptopSkinKeyRegistry";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";
import ScenarioPlayerEvent from "../../../ngt/scenario/ScenarioPlayerEvent";
import ComposerEvent from "../../composer/event/ComposerEvent";
import TimerMediator from "../../timer/view/TimerMediator";
import KeyDecisionContentEvent from "../event/KeyDecisionContentEvent";
import KeyDecisionInteractionEvent from "../event/KeyDecisionInteractionEvent";
import KeyDecision from "../model/KeyDecision";
import KeyDecisionsConfig from "../model/KeyDecisionsConfig";
import KeyDecisionsModel from "../model/KeyDecisionsModel";

export default class RequestKeyDecisionCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {KeyDecisionsModel} keyDecisionsModel 
     * @param {KeyDecisionsConfig} keyDecisionsConfig 
     * @param {NGTDialogPlayer} scenarioPlayer 
     */
    constructor(dispatcher, keyDecisionsModel, keyDecisionsConfig, scenarioPlayer) {
        super(dispatcher);

        this._keyDecisionsModel = keyDecisionsModel;
        this._keyDecisionsConfig = keyDecisionsConfig;
        this._scenarioPlayer = scenarioPlayer;
    }

    execute(evt) {
        /** @type {KeyDecisionInteractionEvent} */
        const data = evt.params.data;
        const keyDecision = data.keyDecision;
        const keyDecisionContent = keyDecision.content;

        const contentType = keyDecisionContent.getType();
        switch (contentType) {
            case ContentTypes.TYPE_EMAIL_DRAFT:
                this._handleDraftEmailKeyDecision(keyDecision);
                return;
            case ContentTypes.TYPE_DIALOG:
                this._handleDialogKeyDecision(keyDecision);
                return;
            case ContentTypes.TYPE_DECISION:
                this._handleMultipleChoiceKeyDecision(keyDecision);
                return;
            case ContentTypes.TYPE_QUIZ:
                this._handleComposerKeyDecision(keyDecision);
                return;
        }

        console.log(`[RequestKeyDecisionCommand] Requested handled key decision content type '${contentType}'.`);
    }

    

    // Draft emails key decisions:
    /**
     * @param {KeyDecision} keyDecision 
     */
    _handleDraftEmailKeyDecision(keyDecision) {
        this._addDraftEmailKeyDecisionListeners();

        this._openKeyDecisionOverlay(keyDecision, 650)
            .finally(_ => {
                const laptopNavigateEvent = new LaptopNavigateEvent(LaptopNavigateEvent.LAPTOP_SHOW_REQUEST, null, null, null, null, false);
                this.dispatch(laptopNavigateEvent.type, { data: laptopNavigateEvent });

                const emailScreenSkin = SkinFactory.getSkin(LaptopSkinKeyRegistry.LAPTOP_EMAIL_SCREEN_SKIN);
                emailScreenSkin.isKeyDecisionRequest = true;
                
                const gotoLaptopEmailScreenEvent = new LaptopNavigateEvent(LaptopNavigateEvent.GOTO_SCREEN_REQUEST, null, emailScreenSkin);
                this.dispatch(gotoLaptopEmailScreenEvent.type, { data: gotoLaptopEmailScreenEvent });

                this.dispatch(EmailInteractionEvent.OPEN_MAILBOX, { boxType: EmailBoxType.DRAFTS });

                const emailConversation = new EmailConversation(keyDecision.id, new EmailDraftItem(keyDecision.content));
                this.dispatch(EmailInteractionEvent.OPEN_CONVERSATION, { conversation: emailConversation });

                this.dispatch(EmailInterfaceEvent.LOCK_INTERFACE);
            });
    }

    _handleDraftEmailSubmit(evt) {
        this._finishDraftEmailKeyDecision();
    }

    _cancelDraftEmailKeyDecision(evt) {
        this._finishDraftEmailKeyDecision();
    }

    _addDraftEmailKeyDecisionListeners() {
        this._handleDraftEmailSubmitBound = this._handleDraftEmailSubmit.bind(this);
        this._dispatcher.addEventListener(EmailInteractionEvent.SUBMIT_DRAFT, this._handleDraftEmailSubmitBound);

        this._cancelDraftEmailKeyDecisionBound = this._cancelDraftEmailKeyDecision.bind(this);
        this._dispatcher.addEventListener(KeyDecisionInteractionEvent.CANCEL_KEY_DECISION, this._cancelDraftEmailKeyDecisionBound);
    }

    _removeDraftEmailKeyDecisionListeners() {
        this._dispatcher.removeEventListener(EmailInteractionEvent.SUBMIT_DRAFT, this._handleDraftEmailSubmitBound);
        this._dispatcher.removeEventListener(KeyDecisionInteractionEvent.CANCEL_KEY_DECISION, this._cancelDraftEmailKeyDecisionBound);
    }

    _finishDraftEmailKeyDecision() {
        this._removeDraftEmailKeyDecisionListeners();

        this._closeKeyDecisionUnderlay();
        this._closeKeyDecisionOverlay();

        this.dispatch(LaptopNavigateEvent.LAPTOP_HIDE_REQUEST);
    }


     // Composer key decisions:
    /**
     * @param {KeyDecision} keyDecision 
     */
    _handleComposerKeyDecision(keyDecision) {
        /** @type {DialogContentComponent} */
        this._dialogContent = keyDecision.content;

        this._addComposerKeyDecisionListeners();

        this._openKeyDecisionOverlay(keyDecision)
            .finally(_ => {
                //Open Composer
                const playDialogEvent = new ScenarioPlayerEvent(ComposerEvent.OPEN_SCREEN_REQUEST, this._dialogContent, this._scenarioPlayer);
                this.dispatch(playDialogEvent.type, { data: playDialogEvent });
        });
    }

    // Dialog key decision:
    /**
     * @param {KeyDecision} keyDecision 
     */
    _handleDialogKeyDecision(keyDecision) {
        /** @type {DialogContentComponent} */
        this._dialogContent = keyDecision.content;

        this._addDialogKeyDecisionListeners();

        this._openKeyDecisionOverlay(keyDecision)
            .finally(_ => {
                const playDialogEvent = new ScenarioPlayerEvent(ScenarioPlayerEvent.PUSH_DIALOG_AVAILABLE, this._dialogContent, this._scenarioPlayer);
                this.dispatch(playDialogEvent.type, { data: playDialogEvent });
            });
    }

    _finishComposerKeyDecision() {
        this._removeComposerDecisionListeners();

        this._closeKeyDecisionUnderlay();
        this._closeKeyDecisionOverlay();
    }

    _handleComposerKeyDecisionContentCompleted(evt) {
        const data = evt.params.data;
        if (data.content !== this._dialogContent) {
            // Content that was completed was not the key decision dialog content. Ignore it.
            return;
        }

        this._finishComposerKeyDecision();
    }

    _cancelComposerKeyDecision(evt) {
        this._finishComposerKeyDecision();
    }

    _addComposerKeyDecisionListeners() {
        this._handleComposerKeyDecisionContentCompletedBound = this._handleComposerKeyDecisionContentCompleted.bind(this);
        this._dispatcher.addEventListener(KeyDecisionContentEvent.KEY_DECISION_CONTENT_COMPLETED, this._handleComposerKeyDecisionContentCompletedBound, this);

        this._cancelComposerKeyDecisionBound = this._cancelComposerKeyDecision.bind(this);
        this._dispatcher.addEventListener(KeyDecisionInteractionEvent.CANCEL_KEY_DECISION, this._cancelComposerKeyDecisionBound);
    }

    _removeComposerDecisionListeners() {
        this._dispatcher.removeEventListener(ScenarioPlayerEvent.KEY_DECISION_CONTENT_COMPLETED, this._handleComposerKeyDecisionContentCompletedBound, this);
        this._dispatcher.removeEventListener(KeyDecisionInteractionEvent.CANCEL_KEY_DECISION, this._cancelComposerKeyDecisionBound);
    }

    _handleDialogKeyDecisionContentCompleted(evt) {
        const data = evt.params.data;
        if (data.content !== this._dialogContent) {
            // Content that was completed was not the key decision dialog content. Ignore it.
            return;
        }

        this._finishDialogKeyDecision();
    }

    _cancelDialogKeyDecision(evt) {
        this._finishDialogKeyDecision();
    }

    _addDialogKeyDecisionListeners() {
        this._handleDialogKeyDecisionContentCompletedBound = this._handleDialogKeyDecisionContentCompleted.bind(this);
        this._dispatcher.addEventListener(KeyDecisionContentEvent.KEY_DECISION_CONTENT_COMPLETED, this._handleDialogKeyDecisionContentCompletedBound, this);

        this._cancelDialogKeyDecisionBound = this._cancelDialogKeyDecision.bind(this);
        this._dispatcher.addEventListener(KeyDecisionInteractionEvent.CANCEL_KEY_DECISION, this._cancelDialogKeyDecisionBound);
    }

    _removeDialogKeyDecisionListeners() {
        this._dispatcher.removeEventListener(ScenarioPlayerEvent.CONTENT_COMPLETED, this._handleDialogKeyDecisionContentCompletedBound, this);
        this._dispatcher.removeEventListener(KeyDecisionInteractionEvent.CANCEL_KEY_DECISION, this._cancelDialogKeyDecisionBound);
    }

    _finishDialogKeyDecision() {
        this._removeDialogKeyDecisionListeners();
        this._closeKeyDecisionUnderlay();
        this._closeKeyDecisionOverlay();
    }

    // Multiple choice key decision:
    /**
     * @param {KeyDecision} keyDecision 
     */
    _handleMultipleChoiceKeyDecision(keyDecision) {
        /** @type {DecisionContent} */
        this._decisionContent = keyDecision.content;

        this._addMultipleChoiceKeyDecisionListeners();

        this._openKeyDecisionOverlay(keyDecision)
            .finally(_ => {
                const playDialogEvent = new ScenarioPlayerEvent(ScenarioPlayerEvent.PUSH_DECISION_DIALOG_AVAILABLE, this._decisionContent, this._scenarioPlayer);
                this.dispatch(playDialogEvent.type, { data: playDialogEvent });
            });
    }

    _handleMultipleChoiceKeyDecisionContentCompleted(evt) {
        const data = evt.params.data;
        if (data.content !== this._decisionContent) {
            // Content that was completed was not the key decision dialog content. Ignore it.
            return;
        }

        this._finishMultipleChoiceKeyDecision();
    }

    _cancelMultipleChoiceKeyDecision(evt) {
        this._finishMultipleChoiceKeyDecision();
    }

    _addMultipleChoiceKeyDecisionListeners() {
        this._handleMultipleChoiceKeyDecisionContentCompletedBound = this._handleMultipleChoiceKeyDecisionContentCompleted.bind(this);
        this._dispatcher.addEventListener(KeyDecisionContentEvent.KEY_DECISION_CONTENT_COMPLETED, this._handleMultipleChoiceKeyDecisionContentCompletedBound, this);

        this._cancelMultipleChoiceKeyDecisionBound = this._cancelMultipleChoiceKeyDecision.bind(this);
        this._dispatcher.addEventListener(KeyDecisionInteractionEvent.CANCEL_KEY_DECISION, this._cancelMultipleChoiceKeyDecisionBound);
    }

    _removeMultipleChoiceKeyDecisionListeners() {
        this._dispatcher.removeEventListener(ScenarioPlayerEvent.CONTENT_COMPLETED, this._handleMultipleChoiceKeyDecisionContentCompletedBound, this);
        this._dispatcher.removeEventListener(KeyDecisionInteractionEvent.CANCEL_KEY_DECISION, this._cancelMultipleChoiceKeyDecisionBound);
    }

    _finishMultipleChoiceKeyDecision() {
        this._removeMultipleChoiceKeyDecisionListeners();
        this._closeKeyDecisionOverlay();
    }


    // Generic:
    _openKeyDecisionOverlay(keyDecision, waitBeforeSuspenseAnimation = 0, showAbortButton = true) {
        return new Promise(resolve => {
            const openUnderlay = _ => this._openKeyDecisionUnderlay(keyDecision, waitBeforeSuspenseAnimation);

            this._keyDecisionOverlaySkin = this.openPopup(SkinKeyRegistry.KEY_DECISION_OVERLAY_SCREEN_SKIN, null, {
                needsOverlay: false,
                priority: 100,
                animationType: AnimationFactory.FADE_TO_COLOR_IN,
                animationOptions: new FadeToColorOptions("#000", 450, 0, 850, createjs.Ease.sineInOut, resolve, [openUnderlay]),
            }, {abortButton: showAbortButton});
        });
    }

    _closeKeyDecisionOverlay() {
        return new Promise((resolve, reject) => {
            if (!this._keyDecisionOverlaySkin) {
                console.warn(`[RequestKeyDecisionCommand] _closeKeyDecisionOverlay, but no overlay is opened.`);
                reject();
                return;
            }

            this.closePopup(this._keyDecisionOverlaySkin, {
                animationType: AnimationFactory.FADE_OUT,
                animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut, resolve),
            });

            this._keyDecisionOverlaySkin = null;
        });
    }

    /**
     * @param {KeyDecision} keyDecision 
     */
    _openKeyDecisionUnderlay(keyDecision, waitBeforeSuspenseAnimation = 0) {
        this._keyDecisionUnderlaySkin = this.openScreen(SkinKeyRegistry.KEY_DECISION_UNDERLAY_SCREEN_SKIN, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        }, {
            backgroundImageId: keyDecision.backgroundImageId,
            transitionInDuration: 750,
            waitBeforeSuspenseAnimation,
        });
    }

    _closeKeyDecisionUnderlay() {
        if (!this._keyDecisionUnderlaySkin) {
            console.warn(`[RequestKeyDecisionCommand] _closeKeyDecisionUnderlay, but no underlay is opened.`);
            return;
        }

        this.closeScreen(this._keyDecisionUnderlaySkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });

        this._keyDecisionUnderlaySkin = null;
    }
}